import * as React from "react";

import { cn } from "@/lib/utils";

/** `inset="sidebar"`: a field in a sidebar panel — its text on the panel's text line (box at 8, 1 + 5 inside → 14, index.css). */
const Input = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement> & { inset?: "panel" | "sidebar" }
>(({ className, type, inset = "panel", ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn("flex h-7 pointer-coarse:h-9 w-full rounded border border-line bg-background py-1 text-body-s", inset === "sidebar" ? "sb-field" : "px-2", " shadow-none transition-colors file:border-0 file:bg-transparent file:text-ui file:font-medium file:text-foreground placeholder:text-dim focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50", className)}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = "Input";

export { Input };
